<script setup>
import { onBeforeMount, onMounted } from "vue";
import { RouterView } from "vue-router";
import { storeSys } from "@/stores/sys.js";
import MyLoading from "@/components/MyLoading.vue";

// onMounted(() => {
//   document.body.style.setProperty("--el-color-primary", "#1976D2");
// });

//監聽頁面刷新的事件
onBeforeMount(() => {
  window.addEventListener("beforeunload", () => {
    localStorage.setItem("token", storeSys.token);
    localStorage.setItem("lastUser", storeSys.lastUser);
  });
});
</script>

<template>
  <RouterView class="app" />
  <MyLoading v-show="storeSys.loadingScreen"></MyLoading>
  <!-- <div v-loading="storeSys.loadingScreen" style="width: 100%; height: 100%; background-color: rgba(0, 0, 0, 0.3)"></div> -->
</template>

<style scoped>
.app {
  position: absolute;
  inset: 0;
}
</style>
